import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import ButtonGroup from "../../components/Button/DynamicButtonGrounp";
import {
  ValuesNormalCount,
  ValuesActiveCount,
  SideBarNormalDiv,
  SideBarNormalDivNew,
} from "../Theme";
import { useHistory, useLocation } from "react-router-dom";

const ValuesCarousel = () => {
  const postValues = useSelector((state) => state.showcase.values);
  // postValues should be the array with the structure you posted, e.g. [{id:58, name:"V3SK", children:[...]}]

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(4);
  const [selectedId, setSelectedId] = useState(0);
  const history = useHistory();
  const location = useLocation();
  const handleNavigate = (valueId) => {
    history.push("/journal", { src: location.pathname, valueId: valueId });
  };
  const getItemsPerPage = () => {
    const width = window.innerWidth;
    if (width < 480) return 1;
    else if (width < 768) return 1;
    else if (width < 992) return 2;
    else if (width < 1024) return 3;
    else return 4;
  };

  useEffect(() => {
    setSelectedId(postValues[0]?.id || 0);
  }, [postValues]);

  useEffect(() => {
    const updateItemsPerPage = () => {
      const newItemsPerPage = getItemsPerPage();
      setItemsPerPage(newItemsPerPage);
      setCurrentPage(0);
    };

    // Run once on mount
    updateItemsPerPage();

    // Listen to resize
    window.addEventListener("resize", updateItemsPerPage);
    return () => window.removeEventListener("resize", updateItemsPerPage);
  }, []);

  // Find selected section by selectedId
  const selectedSection = postValues?.find(
    (section) => section.id === selectedId
  );

  // The children of selectedSection will be paginated
  const sectionsToDisplay = selectedSection?.children || [];

  const totalPages = Math.ceil(sectionsToDisplay?.length / itemsPerPage);

  const handlePrev = () => {
    if (currentPage > 0) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1) setCurrentPage(currentPage + 1);
  };

  const paginatedItems = sectionsToDisplay?.slice(
    currentPage * itemsPerPage,
    currentPage * itemsPerPage + itemsPerPage
  );

  const itemsCount = paginatedItems.length;
  const diff = Math.max(0, itemsPerPage - itemsCount);
  const leading = Math.floor(diff / 2);
  const trailing = diff - leading;

  const buttons =
    postValues?.map((section) => ({
      id: section.id,
      label: section.name,
    })) || [];

  return (
    <div className="cardBackgroundColor p-4 px-5 md:px-10 lg:px-10 xl:px-10 text-sm w-full mt-5 pb-8">
      {/* Header & Pagination */}
      <div className="flex justify-between items-center pt-2">
        <div className="w-full">
          <h2 className="text-center text-xl font-bold flex-1 pb-3">
            My Values and Competencies
          </h2>
          {postValues?.length !== 0 ? (
            <>
              <ButtonGroup
                buttons={buttons}
                selectedId={selectedId}
                onChange={(id) => {
                  setSelectedId(id);
                  setCurrentPage(0);
                }}
              />
            </>
          ) : (
            <>
              <div className="blackColor text-center text-sm">
                Competency is not defined
              </div>
            </>
          )}
        </div>
      </div>
      {postValues?.length !== 0 ? (
        <>
          <div className="flex justify-between items-center pt-2">
            <button
              onClick={handlePrev}
              className={`${
                currentPage === 0 ? "cursor-default opacity-40" : "cursor-pointer "
              } rounded-md border `}
              disabled={currentPage === 0}
            >
              <ChevronLeftOutlinedIcon className="blueColor w-4 h-4" />
            </button>
            <button
              onClick={handleNext}
              className={`${
                currentPage >= totalPages - 1
                  ? "cursor-default opacity-40"
                  : "cursor-pointer "
              } rounded-md border `}
              disabled={currentPage >= totalPages - 1}
            >
              <ChevronRightOutlinedIcon className="blueColor w-4 h-4" />
            </button>
          </div>

          {/* Paginated Items */}
          {/* <div
            className={`grid gap-4 pt-2 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4`}
          > */}
          {/* <div
            className="grid gap-4 pt-2 justify-center"
            style={{
              gridTemplateColumns: `repeat(${Math.min(
                paginatedItems.length,
                itemsPerPage
              )}, minmax(0, 1fr))`,
            }}
          > */}
          <div
            className={`grid gap-4 place-content-center mx-auto pt-2 ${
              itemsPerPage === 4
                ? "grid-cols-4"
                : itemsPerPage === 3
                ? "grid-cols-3"
                : itemsPerPage === 2
                ? "grid-cols-2"
                : "grid-cols-1"
            }`}
          >
            <div className="col-span-full flex justify-center gap-4">
              {paginatedItems.map((section, index) => (
                <div
                  key={section.id || index}
                  className={`"cardBackgroundColor rounded-xl px-4 py-3 boxShadow ${
                    itemsPerPage === 4
                      ? "w-1/4"
                      : itemsPerPage === 3
                      ? "w-1/3"
                      : itemsPerPage === 2
                      ? "w-1/2"
                      : "w-full"
                  } `}
                >
                  <h3 className="blueColor text-lg font-bold mb-4">
                    {section.name}
                  </h3>
                  {section.children?.map((val, idx) => {
                    return val.count !== 0 ? (
                      <SideBarNormalDivNew
                        key={val.value_id || idx}
                        onClick={() => {
                          handleNavigate(val.value_id);
                        }}
                        className={`cursor-pointer flex justify-between items-center blackColor text-sm py-1 px-1`}
                      >
                        <span className="blackColor text-sm">{val.name}</span>
                        <ValuesActiveCount className="px-2 text-xs rounded-full h-5 w-5 flex items-center justify-center">
                          {val?.count || 0}
                        </ValuesActiveCount>
                      </SideBarNormalDivNew>
                    ) : (
                      <div
                        key={val.value_id || idx}
                        className={`flex justify-between items-center blackColor text-sm py-1 px-1`}
                      >
                        <span className="blackColor text-sm">{val.name}</span>
                        <ValuesNormalCount className="px-2 text-xs rounded-full h-5 w-5 flex items-center justify-center">
                          {val?.count || 0}
                        </ValuesNormalCount>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default ValuesCarousel;
